import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const NavigationWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
  position: "relative",
  width: "100%"
}));

export const DotColumn = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  gap: "0.35rem",
  paddingTop: theme.spacing(2),
  width: 24
}));

export const CardsColumn = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  minWidth: 0
}));

interface DotButtonProps {
  $active: boolean;
  $isComplete: boolean;
}

export const DotButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "$active"
})<DotButtonProps>(({ $active, $isComplete, theme }) => ({
  background: $isComplete
    ? theme.customColors.borderSecondaryComplete
    : $active
      ? theme.customColors.accentVariantA
      : theme.customColors.border,
  border: "none",
  borderRadius: "50%",
  cursor: "pointer",
  height: $active ? 12 : 8,
  outline: "none",
  padding: 0,
  transition: "all 0.15s ease",
  width: $active ? 12 : 8,

  "&:focus-visible": {
    boxShadow: `0 0 0 2px ${theme.palette.primary?.main}`,
    outline: "none"
  }
}));
